// @flow
import * as React from 'react';
import moment from 'moment';

import { PrimaryText } from '../../../Typography.jsx';
import { Button } from '../../../Buttons.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  note: Object,
  closePage: Function,
}

class ViewSymptomAnalysis extends React.Component<Props> {
  componentDidMount() {
    if (!Object.keys(this.props.note).length) {
      this.props.closePage();
    }
  }

  render() {
    const data = this.props.note || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <ContentBox title='Symptom Analysis'>
        <div className={styles.notes}>
          <PrimaryText>Chief Complaint</PrimaryText><br />
          {data.complaint || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Onset</PrimaryText><br />
          {data.onset || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Location</PrimaryText><br />
          {data.location || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Duration</PrimaryText><br />
          {data.duration || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Characteristics</PrimaryText><br />
          {data.characteristics || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Aggravating Factors</PrimaryText><br />
          {data.aggravatingFactors || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Relieving Factors</PrimaryText><br />
          {data.relievingFactors || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Treatment</PrimaryText><br />
          {data.treatment || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Associated Signs and Symptoms</PrimaryText><br />
          {data.signsSymptoms || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Notes</PrimaryText><br />
          {data.notes || '--'}
        </div>
        <table>
          <tbody>
            <tr>
              <td><PrimaryText>Exam Date </PrimaryText></td>
              <td>{data.date ? moment(data.date).format('DD-MM-YYYY, HH:mm') : '--'}</td>
            </tr>
            <tr className={styles.editHistoryRow}>
              <td><strong>Edit History </strong></td>
              <td>{editHistory || '--'}</td>
            </tr>
          </tbody>
        </table>
        <Button onClick={this.props.closePage}>Close</Button>
      </ContentBox>
    );
  }
}

export default ViewSymptomAnalysis;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewSymptomAnalysis.jsx